import { Settings } from "../../Settings";
import GridTile from "../grid/GridTile";
import LayerDescription from "../grid/LayerDescription";
import BasicTerrainLayer from "./BasicTerrainLayer";
import FractionalBrownianMotion from "./FractionalBrownianMotion";

/**
 * @extends {BasicTerrainLayer}
 */
export default class GrassTerrainLayer extends BasicTerrainLayer {
    /**
     * @param {LayerDescription} layerDescription
     * @param {FractionalBrownianMotion} fbm 
     */
    constructor(layerDescription, fbm) {
        super(layerDescription, fbm);
    }

    /**
     * @override
     * @param {GridTile} tile The tile
     * @param {number} tileDepth The depth of the tile in tile rows.
     * @returns {boolean}
     */
    isLayerForTile(tile, tileDepth) {
        // If the tile is outside the adjusted range for this layer, then don't bother doing noise calculations
        if (!this.isInAdjustedRange(tileDepth)) {
            return false;
        }

        const origin = tile.origin;

        // Calculate the max layer depth for this terrain column
        // Multiply the noise by some factor (I chose tile size) to increase the effect, and also
        // sort of to put it into tile coordinates.
        const noiseAdjustment = Settings.tile.size * this.fbm.calculateNoise(origin.x, origin.x); // <-- This is different from the BasicTerrainLayer implementation
        const adjustedMinLayerDepth = this.minTileDepth + noiseAdjustment - 5; // -5 to make hilltops not be at 0 depth

        // If the tile depth is greater than the ajusted min layer depth, then it is inside this terrain layer.
        return tileDepth >= adjustedMinLayerDepth;
    }

}